import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {PartnerRequestReport} from 'src/app/shared/Models/PartnerRequestReport'

@Component({
  selector: 'app-partner-request-report',
  templateUrl: './partner-request-report.component.html',
  styleUrls: ['./partner-request-report.component.css']
})
export class PartnerRequestReportComponent  {
  ReportsInfo = new PartnerRequestReport()
  ReceiptBooks: any;
  ReceiptStatus: any;
  constructor(private router: Router) {
  
  }
  ngOnInit(): void {
  }
 
 

  Viewreports() {
  
    localStorage["ReportName"] = "PartnerRequestReport";
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));

    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }
}
